export default __webpack_public_path__ + "static/media/img--bathroom-dark.b5053fed.jpg";